module.exports = __webpack_public_path__ + "media/images/common/3column_product_bg_ynx-5b682f86fd112db89b1e16badd5b83d4.png";